import * as React from "react";
import {Fragment} from "react";
import JobBDPChangeNotification from "../../../model/notification/assignee/job/JobBDPChangeNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: JobBDPChangeNotification
}

/**
 * Job BDP change notification toast body.
 */
const NotificationJobBDPChangeBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Job {props.notification.data.getJobReferenceNumber()}</div>
			<div className={"toast-body"}>
				Business Development Partner changed from <b>{props.notification.displayPreviousAssignee()} </b>
				to <b>{props.notification.displayCurrentAssignee()}</b>
			</div>
		</Fragment>
	);
};

export default NotificationJobBDPChangeBody;
